import axios from 'axios';
import dashboard from './dashboard';
import pages from './pages';
import utilities from './utilities';
import other from './other';

import eServices from './eServices';
import organizations from './organizations';
import services from './services';
import fedi from './fedi'
import certServices from './certServices';
import vmaServices from './vmaServices';

// ==============================|| MENU ITEMS ||============================== //

const retrieveUserData = async () => {
    try {
        const res = await axios.get('/api/getUserDataFromSession');
        return res.data.response;
    } catch (error) {
        console.error(error.response.data);
        return null;
    }
}
const userData = await retrieveUserData();

const menuItems = {
    items: userData ? ([organizations(userData), services, eServices, fedi, certServices, vmaServices]) : []
    
    // userData && (userData.role === process.env.REACT_APP_TC_ADMIN_ROLE_NAME || userData.role === process.env.REACT_APP_SUPER_USER_TC_ID) ? 
    //     [organizations(userData), services, eServices, fedi, certServices, vmaServices]
    //     :
    //     userData && (userData.role === process.env.REACT_APP_CONTRACTS_MANAGER_ROLE_NAME || userData.role === process.env.REACT_APP_EXECUTIVE_ROLE_NAME) ?
    //     [organizations(userData)] : []
};

export default menuItems;